






import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  mounted() {
    const el = this.$refs.box as any;
    el.addEventListener('scroll', () => {
      const { scrollHeight, scrollTop, clientHeight } = el;
      if (scrollTop + clientHeight + 10 > scrollHeight) {
        this.$emit('reachBottom');
      }
    });
  },
});
